
import axios from 'axios';

const client = axios.create({
    baseURL: import.meta.env.VITE_APP_BELOZ_V2_ENDPOINT,
});

export const validatePhoneOTPService = async (authToken, otp, resetToken) => {
    try {
        const { data } = await client.post(
            '/otp/phone/validation',
            {
                phoneToken: resetToken,
                otpCode: otp,
            },
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            },
        );
        return {
            success: data.success,
            data: data.data,
        };
    } catch (error) {
        console.error('validateCodeCDC', error?.response?.data?.message);
        return {
            success: false,
            error: error?.response?.data?.message,
        };
    }
};

export const requestPhoneOTPService = async (
    authToken,
    phoneNumber,
    messageType = 'whatsapp',
) => {
    try {
        const { data } = await client.post(
            '/otp/phone/send',
            {
                phone: `+52${phoneNumber}`,
                messageType,
            },
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            },
        );
        return data;
    } catch (error) {
        console.error('requestCodeCDCService', error);
        return {
            success: false,
            error: error.response.data,
        };
    }
};